import React from 'react';
import TicketStubRow from '../row';
import TicketStubCell from '../cell';
import translate from '../../../../utils/translate';
import U from '../ticket_stub_utils';

const T = React.PropTypes;

export default class TypeSectionTicket extends React.Component {
  static propTypes = {
    ticket: T.object,
    onClick: T.func
  };

  render () {
    return (
      <div>
        <TicketStubRow>
          <TicketStubCell
            isDisabled={U.isDisabled(this.props.ticket)}
            header={translate('pageTranslations', 'TICKET_STUB_TYPE')}
            text={this.props.ticket.seat_name.type} />
        </TicketStubRow>
        <TicketStubRow>
          <TicketStubCell
            isDisabled={U.isDisabled(this.props.ticket)}
            header={translate('pageTranslations', 'TICKET_STUB_SECTION')}
            text={this.props.ticket.seat_name.sec} />
        </TicketStubRow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/templates/type_section_ticket.js